import { useCallback, useEffect, useRef } from "react";

function useTouchHold(callback, holdSeconds) {
  const touchStartTimeRef = useRef(null);
  const touchTimeoutRef = useRef(null);
  const callbackRef = useRef(callback);
  const elementRef = useRef(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const element = elementRef.current;

    function handleTouchStart() {
      try {
        touchStartTimeRef.current = Date.now();
        touchTimeoutRef.current = setTimeout(() => {
          if (touchStartTimeRef.current) {
            callbackRef.current();
          }
        }, holdSeconds * 1000);
      } catch (error) {
        console.error(error);
      }
    }

    function handleTouchEnd() {
      clearTimeout(touchTimeoutRef.current);
      touchStartTimeRef.current = null;
    }

    if (element) {
      element.addEventListener("touchstart", handleTouchStart);
      element.addEventListener("touchend", handleTouchEnd);
    }

    return () => {
      if (element) {
        element.removeEventListener("touchstart", handleTouchStart);
        element.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, [holdSeconds]);

  const onRef = useCallback((node) => {
    elementRef.current = node;
  }, []);

  return [onRef];
}

export default useTouchHold;
